import { render, staticRenderFns } from "./with_item.vue?vue&type=template&id=7d23d470"
import script from "./with_item.vue?vue&type=script&lang=js"
export * from "./with_item.vue?vue&type=script&lang=js"
import style0 from "./with_item.vue?vue&type=style&index=0&id=7d23d470&prod&lang=css"
import style1 from "./with_item.vue?vue&type=style&index=1&id=7d23d470&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports